import { createSelector } from '@reduxjs/toolkit';
const reduxDynamicApprovalValuesReducer = (state) => state.reduxDynamicApprovalValues;
export const reduxDynamicApprovalValuesSelector = createSelector(reduxDynamicApprovalValuesReducer, (reducer) => reducer.data);
